import StandardPopup from "../Global/StandardPopup/StandardPopup";

const AttendancePrompts = ({
  popup,
  closePopup,
  retryPrompt,
  setRetryPrompt,
  choicePrompt,
  setChoicePrompt,
  onlinePrompt,
  setOnlinePrompt,
  validateWithLocation,
  handleQueueAdd,
  t
}) => {
  return (
    <>
      <StandardPopup
        isOpen={!!popup}
        message={popup || ""}
        onClose={closePopup}
        buttonsEnabled={false}
      />

      <StandardPopup
        isOpen={retryPrompt}
        message={t.retryPrompt}
        yesFcn={() => { setRetryPrompt(false); validateWithLocation({ addToQueueOnFail: false }); }}
        noFcn={() => setRetryPrompt(false)}
      />

      <StandardPopup
        isOpen={choicePrompt}
        message={t.choicePromptMessage}
        yesText={t.choiceProximity}
        noText={t.choiceManual}
        yesFcn={() => { setChoicePrompt(false); validateWithLocation({ addToQueueOnFail: true }); }}
        noFcn={() => { setChoicePrompt(false); handleQueueAdd(t.manualValidationRequested); }}
        onClose={() => setChoicePrompt(false)}
      />

      <StandardPopup
        isOpen={onlinePrompt}
        message={t.onlinePromptMessage}
        yesText={t.onlineYes}
        noText={t.onlineNo}
        yesFcn={() => { setOnlinePrompt(false); handleQueueAdd(t.onlineSuccess); }}
        noFcn={() => setOnlinePrompt(false)}
        onClose={() => setOnlinePrompt(false)}
      />
    </>
  );
};

export default AttendancePrompts;
